import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { DisclosureArrow } from 'components/DisclosureArrow/DisclosureArrow';
import { Panel } from './Panel';
import { Controls } from './Controls';
import css from './Selector.scss';

class Selector extends React.Component {
  constructor(props) {
    super(props);

    this.renderControls.displayName = 'Controls';
    this.renderDisclosureArrow.displayName = 'DisclosureArrow';
    this.renderSelection.displayName = 'Selection';
    this.renderPanel.displayName = 'Panel';
  }

  getClasses = () => {
    const { extraClass, isSelected } = this.props;

    return cx(css.selection, extraClass, {
      [css['selection--selected']]: isSelected,
    });
  };

  renderDisclosureArrow = ({ className, isOpen = this.props.isOpen }) => (
    <DisclosureArrow className={cx(css.selection__arrow, className)} open={isOpen} />
  );

  renderPanel = props => {
    const { isMobile, isOpen } = this.props;

    return (
      <Panel {...props} isMobile={isMobile} isOpen={isOpen}>
        {props.children}
      </Panel>
    );
  };

  renderSelection = ({ children }) => {
    const { onToggle } = this.props;
    return (
      <span className={this.getClasses()} onClick={onToggle}>
        {children}
      </span>
    );
  };

  renderControls = ({ children, className, disableClearControl, onClear, onDone, clearPrompt }) => (
    <Controls
      className={className}
      disableClearControl={disableClearControl}
      onClear={onClear}
      onDone={onDone}
      clearPrompt={clearPrompt}>
      {children}
    </Controls>
  );

  render() {
    const { children, isOpen } = this.props;

    return children({
      Controls: this.renderControls,
      DisclosureArrow: this.renderDisclosureArrow,
      Panel: this.renderPanel,
      Selection: this.renderSelection,
      classes: this.getClasses(),
      isOpen,
    });
  }
}

Selector.propTypes = {
  children: PropTypes.func.isRequired,
  extraClass: PropTypes.string,
  isMobile: PropTypes.bool,
  isOpen: PropTypes.bool,
  isSelected: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

export { Selector };
